<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load" class="align-items-center">
                    <b-col lg="2" sm="12" class="text-left">
                        <lg-form-const-select label="Situação:" @change="load()" v-model="form.situacao"
                            :options="form.optionsFilterSituacao" />
                    </b-col>
                    <b-col lg="6" sm="12" class="text-left">
                        <lg-form-input v-model="form.descricao" label="Descrição:" description=" " />
                    </b-col>

                    <b-col lg="1" sm="1" class="ml-1 d-flex justify-content-end align-items-center">
                        <b-button id="localizar" class="ml-1 mr-2 my-1" size="sm" style="height: 20px" pill
                            variant="primary" @click="load">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizar" title="Localizar"></b-tooltip>
                        </b-button>
                    </b-col>

                    <b-col lg="2" sm="12" class="text-right d-flex justify-content-end align-items-center">
                        <b-button id="novo" class="ml-3 mr-2 my-2" style="height: 20px" @click="showGrupoModal(null)"
                            size="sm" pill variant="secondary" v-if="addBtnVisible">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                            <b-tooltip target="novo" title="Adicionar novo..."></b-tooltip>
                        </b-button>
                    </b-col>
                </b-form-row>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.grupos" :fields="this.tableFields"
                    :filter="filtro" :hover="true" show-empty @row-dblclicked="grupoSelect">
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(situacao)="row">
                            <b-form-checkbox v-b-tooltip.hover.bottom="'Ativar/desativar...'" v-model="row.item.situacao" @change="alteraSituacao(row.item)"
                                name="check-button" switch size="lg" :value="1" :unchecked-value="0" />
                    </template>

                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>

                    <template v-slot:cell(editar)="row">
                        <b-button :id="row.index + 'edit-buttonGrupo'" size="sm" pill variant="primary"
                            @click="editarGrupo(row.item)">
                            <b-icon v-b-tooltip.hover.bottom="'Editar'" icon="pencil-square" />
                        </b-button>
                    </template>

                    <template v-slot:cell(subgrupo)="row">
                        <b-button  :id="row.index + 'subgrupo'" size="sm" pill
                            variant="primary" @click="showSubgrupoModal(row.item)" v-if="visible">
                            <b-icon v-b-tooltip.hover.top="'Subgrupo'" icon="list-ul" />
                        </b-button>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                            totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <modal-subgrupo-list-novo v-if="showModalSubgrupo" @close="cancelarSubgrupoModal" :prefix="title"
            :currentGrupo="currentGrupo" />

        <grupo-produto-form v-if="showModalGrupo" @close="cancelar" :prefix="title" :id="currentGrupoId" />
    </b-card>
</template>

<script>
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import GrupoProdutoForm from "./GrupoProdutoForm.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import GrupoProdutoService from "@/core/api/GrupoProdutoService.js"
import ModalSubgrupoListNovo from "@/components/Modal/ModalSubgrupoListNovo.vue"

export default {
    name: "GrupoProdutoList",
    components: {
        GrupoProdutoForm,
        LgFormInput,
        LgFormConstSelect,
        ModalSubgrupoListNovo,
    },
    mixins: [ConfirmMixin, ListResourceMixin],

    props: {
        onDblClickGrupo: Function,
        title: {
            type: String,
            default: "Grupo de Produto",
        },
        visible: {
            type: Boolean,
            default: true,
        },
        addBtnVisible: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            showModalSubgrupo: false,
            showModalGrupo: false,
            currentGrupoId: null,
            currentGrupo: {},
            currentSubgrupoId: null,
            form: {
                descricao: "",
                situacao: 1,
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: null },
                    { key: "filterSituacao", text: "Ativo", value: 1 },
                    { key: "filterSituacao", text: "Inativo", value: 0 },
                ],
            },
            grupos: [],
        }
    },

    beforeMount() {
        this.$GrupoProdutoService = new GrupoProdutoService()

        this.load()
    },

    mounted() {
        this.load()
    },

    watch: {
        page() {
            this.load()
        },
    },

    computed: {
        tableFields() {
            return [
                {
                    key: "numero",
                    label: "N",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-left",
                },
                {
                    key: "descricao",
                    label: "Descrição",
                    thStyle: "width: 20rem; font-size: 16px; ",
                    tdClass: "text-left ",
                },
                {
                    key: "editar",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },
                {
                    key: "situacao",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },
                {
                    key: "subgrupo",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },
            ]
        },
    },

    methods: {
        async load() {
            this.filtro = {}
            if (this.form.descricao) {
                this.filtro.descricao = this.form.descricao
            }

            if (this.form.situacao != null) {
                this.filtro.situacao = this.form.situacao
            }
            this.busy = true
            try {
                const response = await this.$GrupoProdutoService.findAll({
                    size: this.perPage,
                    page: this.page,
                    params: this.filtro,
                })
                if (response && Array.isArray(response.content)) {
                    this.grupos = response.content.map(item => ({
                        ...item,
                        form: {
                            situacao: item.situacao === 1,
                        },
                    }))
                }
            } catch (error) {
                console.log("Error loading grupos:", error)
                this.grupos = []
            } finally {
                this.busy = false
            }
        },

        grupoSelect(grupo) {
            this.$emit("onDblClickGrupo", grupo)
        },

        editarGrupo(grupo) {
            this.currentGrupoId = grupo.id
            this.showModalGrupo = true
        },

        cancelar() {
            this.currentGrupoId = null
            this.showModalGrupo = false
            this.load()
        },

        showGrupoModal() {
            this.showModalGrupo = true
        },

        showSubgrupoModal(grupo) {
            this.currentGrupo = grupo
            this.showModalSubgrupo = true
        },

        cancelarSubgrupoModal() {
            this.showModalSubgrupo = false
        },

        async alteraSituacao(item) {
            let response
            if (item.situacao === 1) {
                response = await this.$confirm(
                    "Deseja ativar o Grupo?",
                    item.descricao.toUpperCase()
                )
            }
            if (item.situacao === 0) {
                response = await this.$confirm(
                    "Deseja desativar o Grupo?",
                    item.descricao.toUpperCase()
                )
            }
            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacao = item.situacao === 1 ? 0 : 1
            }
        },

        async confirmarAlteracaoSituacao(item) {
            const { status } = await this.$GrupoProdutoService.alteraSituacao(item)
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
                        } o registro!`,
                })
            }
        },
    },
}
</script>
